// Ubicación en el repo: src/lib/oftsales.js
// Ventas OFT (¿el paciente compró lentes o no?) — tabla `oftsales`, ya
// creada desde la migración inicial (0001) y con RLS lista (0003:
// oftsales_select/insert/update, filtran por patient_branch_match, delete
// siempre false — mismo patrón de soft-delete que el resto). No tiene
// professional_id ni branch_id propio en el prototipo (línea ~2606-2658),
// así que se replica igual acá: solo paciente, fecha, compró/no compró,
// precio (si compró) y notas. Sin fase de impresión — el prototipo tampoco
// la tiene para este módulo.
import { supabase } from './supabaseClient';

const OFTSALE_LIST_SELECT =
  'id, patient_id, date, compro, price, notes, ' +
  'patients(nombre, apellido, segundo_nombre, segundo_apellido, rut, patient_branches(branch_id))';

// Mismo patrón en dos capas que listPrescriptions/listExams: RLS ya
// restringe por patient_branch_match, esto solo acota a la sucursal activa
// elegida en el header.
export async function listOftsales({ branchId, search } = {}) {
  const { data, error } = await supabase
    .from('oftsales')
    .select(OFTSALE_LIST_SELECT)
    .is('deleted_at', null)
    .order('date', { ascending: false });
  if (error) throw error;

  let rows = data ?? [];
  if (branchId) {
    rows = rows.filter((r) => (r.patients?.patient_branches ?? []).some((pb) => pb.branch_id === branchId));
  }
  const term = search?.trim().toLowerCase();
  if (term) {
    rows = rows.filter((r) => {
      const p = r.patients;
      if (!p) return false;
      const name = [p.nombre, p.segundo_nombre, p.apellido, p.segundo_apellido].filter(Boolean).join(' ').toLowerCase();
      return name.includes(term) || (p.rut || '').toLowerCase().includes(term);
    });
  }
  return rows;
}

export async function createOftsale(values, actorId) {
  const { error } = await supabase.from('oftsales').insert({
    ...values,
    created_by: actorId,
    updated_by: actorId,
  });
  if (error) throw error;
}

export async function updateOftsale(id, values, actorId) {
  const { error } = await supabase
    .from('oftsales')
    .update({ ...values, updated_by: actorId })
    .eq('id', id);
  if (error) throw error;
}

export async function softDeleteOftsale(id, actorId) {
  const { error } = await supabase
    .from('oftsales')
    .update({ deleted_at: new Date().toISOString(), deleted_by: actorId })
    .eq('id', id);
  if (error) throw error;
}
